{
  "cancel": {},
  "communicationError": {
    "cancel": {},
    "tryAgain": {}
  },
  "name": {},
  "report": {},
  "run": {},
  "success": {
    "close": {}
  },
  "unsuccess": {
    "back": {},
    "cancel": {},
    "proceedAnyway": {}
  }
}
